import { render, staticRenderFns } from "./tamsense-metric.vue?vue&type=template&id=5374f3b8&"
import script from "./tamsense-metric.vue?vue&type=script&lang=js&"
export * from "./tamsense-metric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports